import React from 'react';
import _ from 'lodash';
import cx from 'classnames';



export const Card = ({ className, ...props }) => 
  <div className={cx("g-card", className)} {...props} />
export default Card;

export const CardHead = ({ className, ...props }) => 
  <div className={cx("card-head", className)} {...props} />


export const CardTitle = ({ className, ...props }) => 
  <div className={cx("card-title", className)} {...props} />

export const CardActions = ({ className, ...props }) => 
  <div className={cx("card-actions", className)} {...props} />

export const CardItem = ({ className, ...props }) => 
  <div className={cx("card-item", className)} {...props} />

export const CardInputItem = ({ className, ...props }) => 
  <CardItem className={cx("card-input-item", className)} {...props} />

export const ItemLabel = ({ className, ...props }) => (
  <div className={cx("item-label", className)} {...props} />
);

export const ItemInput = ({ className, ...props }) => (
  <div className={cx("item-input", className)} {...props} />
);

export const ItemActions = ({ className, ...props }) => (
  <div className={cx("item-actions", className)} {...props} />
);

